import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue'
import { CounterInfo } from '@/components/counters/types/CounterTypes'
import LfGrayCounterComponent from '@/components/counters/LfGrayCounterComponent.vue'

// import { ProfitabilitySummaryItem } from '@/components/Dialog/customDialogs/globalVisionProfitability/types/globalVisionProfitabilityDialogTypes'
// import { splitArray } from '@/helpers/array'

type Data = {
  label: string
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalVisionProfitabilitySummaryFormulaComponent',
  props: {
  summary: {
    type: Array as PropType<Array<Data>>,
    required: true
  }
},
  setup(__props) {

const { summary } = __props;



// COMPUTED
const rentabilityCounter = computed<CounterInfo>(() => {
  return {
    title: `${summary[2].label} (G/I)`,
    qty: summary[2].value
  }
})

const parseCounters = computed(() => {
  return summary.map((item: any) => ({
    title: item.label,
    qty: item.value
  }))
})

return { __sfc: true,rentabilityCounter, parseCounters, LfGrayCounterComponent }
}

})